// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2wFLS","left":"styles_left__1AJKm"};